import React from 'react';
import { Block } from 'slate';
import Columns from './Columns';
import Column from './Column';

export default function ColumnsPlugin(options) { // eslint-disable-line
  return {
    schema: {
      blocks: {
        col: {
          isVoid: false,
          nodes: [
            {
              match: [
                { object: 'block', type: 'paragraph' },
                { object: 'block', type: 'video' },
                { object: 'block', type: 'image' },
              ],
              min: 1,
            },
          ],
          normalize: (editor, { code, node, index }) => {
            if (code === 'child_object_invalid') {
              const block = Block.create('paragraph');
              editor.insertNodeByKey(node.key, index, block);
            }
          },
        },
      },
    },

    onKeyDown(event, editor, next) {
      const { startBlock } = editor.value;
      if (event.key === 'Backspace' && startBlock.type === 'paragraph'
          && editor.value.document.nodes.size > 1
          && startBlock.nodes.size === 1
          && startBlock.nodes.first().object === 'text'
          && startBlock.nodes.first().text === '') {
        editor.removeNodeByKey(startBlock.key);
      } else if (event.key === 'Enter' && startBlock.type === 'col') {
        editor.insertText('\n');
      } else if (event.key === 'Backspace' && startBlock.type === 'col') {
        // do nothing
      } else {
        next();
      }
    },

    renderBlock(props, editor, next) {
      switch (props.node.type) {
        case 'columns':
          return <Columns editor={editor} {...props} />;
        case 'col':
          return <Column {...props} />;
        default:
          return next();
      }
    },
  };
}
